"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _propTypes2 = _interopRequireDefault(require("../../../constants/propTypes"));

var _LinkButton = require("./LinkButton.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Basic LinkButton component, intended for external events triggered by clicking on a link.
 * We should also be able to use this to programmatically execute routing.
 */
// intentionally left as a functional component
var LinkButton = function LinkButton(_ref) {
  var className = _ref.className,
      children = _ref.children,
      dataTestId = _ref.dataTestId,
      isBlock = _ref.isBlock,
      overDark = _ref.overDark,
      onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["className", "children", "dataTestId", "isBlock", "overDark", "onClick"]);

  return /*#__PURE__*/_react.default.createElement(_LinkButton.StyledLinkButton, _extends({
    className: className,
    "data-test-id": dataTestId,
    isBlock: isBlock,
    onClick: onClick,
    overDark: overDark,
    type: "button"
  }, props), children);
};

LinkButton.propTypes = {
  /** any nodes that are valid children of a button tag */
  children: _propTypes2.default.children,

  /** Hook for overriding top-level component styles */
  className: _propTypes.default.string,

  /** Test ID hook */
  dataTestId: _propTypes.default.string.isRequired,

  /** Flag for displaying the element as inline-block (so that you can set width if ever desired, and will respect top and bottom margins) */
  isBlock: _propTypes.default.bool,

  /** styling flag for displaying over a dark background */
  overDark: _propTypes.default.bool,

  /** onClick function */
  onClick: _propTypes.default.func
};
LinkButton.defaultProps = {
  children: undefined,
  className: '',
  isBlock: false,
  overDark: false,
  onClick: function onClick() {}
};
var _default = LinkButton;
exports.default = _default;